module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10186.3457808b.jpg";